import { z } from 'zod';
import { EXPERIMENT_PRIMARY_METRICS } from './campaignExperiment.js';
export const STEP_EXPERIMENT_TYPES = ['subject', 'body', 'cta', 'template'];
export const campaignStepExperimentVariantSchema = z
    .object({
    variant_key: z
        .string()
        .min(1)
        .max(8)
        .regex(/^[A-Za-z0-9]+$/),
    label: z.string().max(120).optional().nullable(),
    weight: z.number().int().min(1).max(1000).default(50),
    email_template_id: z.string().uuid().optional().nullable(),
    subject_template: z.string().max(500).optional().nullable(),
    body_text_template: z.string().max(20000).optional().nullable(),
})
    .refine((v) => Boolean(v.email_template_id?.trim()) ||
    Boolean(v.subject_template?.trim()) ||
    Boolean(v.body_text_template?.trim()), { message: 'Variant needs template id or inline subject/body override' });
export const campaignStepExperimentUpsertSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    step_order: z.number().int().min(0).max(99),
    experiment_type: z.enum(STEP_EXPERIMENT_TYPES).optional().default('template'),
    primary_metric: z.enum(EXPERIMENT_PRIMARY_METRICS).optional().default('reply_rate'),
    variants: z.array(campaignStepExperimentVariantSchema).min(2).max(8),
});
//# sourceMappingURL=campaignStepExperiment.js.map